// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ab8c94c","223":"53ad1dca","238":"d4aa24a6","455":"39fba6f8","557":"f7c001ee"}[chunkId] + ".chunk.js";
};